// Libs
import React, { ReactElement } from 'react';
import clsx from 'clsx';
// App
import styles from './gutter.module.scss';
import { GutterProps } from './gutter-props';

/**
 * Create a gutter for pages for width > to large screens
 * Designed to be used as child of a page
 * @param props the component props
 */
const Gutter = (props: GutterProps): ReactElement => {
  const { children, className, fullWidth, autoMargin = true } = props;

  return (
    <div className={clsx(styles.gutter, fullWidth && styles.fullWidth, autoMargin && styles.autoMargin, className)}>
      {children}
    </div>
  );
};

export default Gutter;
